import parsePhoneNumber from 'libphonenumber-js/mobile'

export const format = (phone) => {
  try {
    const phoneNumber = parsePhoneNumber(phone)

    return phoneNumber.format('INTERNATIONAL')
  } catch (error) {
    return phone
  }
}

export const formatE164 = (phone) => {
  try {
    const phoneNumber = parsePhoneNumber(phone)

    return phoneNumber.format('E.164')
  } catch (error) {
    return ''
  }
}

export const isValid = (phone) => {
  if (phone?.includes('*')) return true

  try {
    const parsedPhoneNumber = parsePhoneNumber(phone)

    // Prevent submission of UK numbers that are too short (e.g. +44 7400 12345)
    // Valid UK mobile numbers typically have at least 10 digits after the country code
    if (parsedPhoneNumber.countryCallingCode === '44' && parsedPhoneNumber.nationalNumber.length < 10) {
      return false
    }
    // end of hack

    return parsedPhoneNumber.isPossible()
  } catch (error) {
    return false
  }
}

export const hidden = (phone) => {
  return format(phone).replace(
    /^([^\d]*\d+)\s(.*)(\d{2})$/,
    (match, m1, m2, m3) => m1 + ' ' + m2.replace(/\d/g, '*') + m3,
  )
}
